<template>
  <TemplateDemandBooking2 />
</template>

<script>
import TemplateDemandBooking2 from "@/views/Templates/Demand/TemplateDemandBooking2";
import { onMounted } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "Booking2",
  components: {
    TemplateDemandBooking2,
  },
  setup() {
    onMounted(async () => {
      nativeHandlerService.demand.ncSetDemandIndex(2);
    });
  },
};
</script>
